export default __webpack_public_path__ + "static/media/21.68a1f2f3.png";